<template>
    <v-container fluid grid-list-md v-if="!translations.loading">
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <item-list
                        :items="translations"
                        :data-table-config="dataTableConfig"
                        :actions="actions"
                        :lockActions="lockActions"
                        header="Übersetzungen"
                        show-actions
                ></item-list>
                <i18n-dialog
                        title="Übesetzung bearbeiten"
                        :value.sync="dialog"
                        :translation.sync="selectedTranslation" @ok="ok"
                ></i18n-dialog>
            </v-flex>
        </v-layout>
    </v-container>

    <v-progress-circular
            v-else
            indeterminate
            color="primary"
    ></v-progress-circular>
</template>

<script>
    import ItemList from '../../components/common/ItemList';
    import I18nDialog from "../../components/admin/I18nDialog";

    export default {
        components: {
            ItemList,
            I18nDialog
        },
        data() {
            return {
                dialog: false,
                selectedTranslation: {
                    key: '',
                    de: '',
                    en: ''
                },
                loading: false,
                translations: {
                    loaded: false,
                    items: []
                },
                translationObject: {},
                lockActions: false,
                saving: false,
                dataTableConfig: {
                    loadingDataText: 'Lade Übersetzungen',
                    rowsPerPageText: 'Zeilen pro Seite',
                    headers: [
                        {text: 'Schlüssel', value: 'key', align: 'left'},
                        {text: 'Deutsch', value: 'de', align: 'left'},
                        {text: 'Englisch', value: 'en', align: 'left'}
                    ],
                    items: {
                        large: [
                            {value: 'key'},
                            {value: 'de', formatFunction: '$trimText'},
                            {value: 'en', formatFunction: '$trimText'},
                        ],
                        small: [
                            {value: 'key'},
                            {value: 'de'},
                            {value: 'en'},
                        ]
                    }
                },
                actions: [
                    {
                        label: this.$t('edit'),
                        icon: 'edit',
                        click: item => {
                            this.selectedTranslation = item;
                            this.dialog = true;
                        }
                    }
                ]
            }
        },
        mounted() {
            this.loadTranslations();
        },
        methods: {
            loadTranslations() {
                this.translations.loaded = false;

                axios.get('/api/v1/i18n/translations').then(response => {
                    this.translations.items = [];

                    this.translationObject = response.data;
                    this.parseTranslations();

                    this.translations.loaded = true;
                });
            },
            parseTranslations(object = null, path = null) {
                if (object === null) {
                    object = this.translationObject.de;
                }

                _.each(object, (value, key) => {

                    if (value instanceof Object) {
                        this.parseTranslations(value, path !== null ? `${path}.${key}` : key)
                    } else {
                        let en = '';
                        if (this.translationObject.en.hasOwnProperty(key)) {
                            en = this.getObject(this.translationObject.en, key);
                        }

                        this.translations.items.push({key: (path !== null ? `${path}.${key}` : key), de: value, en: en});
                    }
                });
            },
            getObject(object, key) {
                if (key.includes('.')) {
                    let keys = key.split('.');
                    let tempValue = value;

                    _.each(keys, key => {
                        if (tempValue === null || tempValue[key] === undefined) {
                            tempValue = null;
                            return false;
                        }
                        tempValue = tempValue[key];
                    });

                    return tempValue;
                }

                return object[key];
            },
            ok(translation) {
                //console.log(trans);
                //TODO update with translation parameter instead of ajax request
                this.loadTranslations();
            }
        }
    }
</script>
